import { emptySplitApi } from './index'

export const favoriteFundersApi = emptySplitApi.injectEndpoints({
    endpoints: (builder) => ({
        getFavoriteFundersPagedList: builder.mutation({
            query: (model) => ({
                url: `api/v1/foundation-service/favorite-funders?`
                    + `favoriteId=${model?.favoriteId || ''}`
                    + `&pageNumber=${model?.pageNumber || 0}`
                    + `&pageSize=${model?.pageSize || ''}`
                    + `&orderField=${model?.orderField || 'userName'}`
                    + `&orderDirection=${model?.orderDirection || 'asc'}`,
                method: "GET",
            }),
        }),
        // Cached by favoriteId for the Quick Qualification queue, so paging through funders doesn't
        // re-fetch the whole list on every Prev/Next - only when the list itself changes (see invalidatesTags below).
        getFavoriteFundersQueue: builder.query({
            query: (favoriteId) => ({
                url: `api/v1/foundation-service/favorite-funders?`
                    + `favoriteId=${favoriteId || ''}`
                    + `&pageNumber=0`
                    + `&pageSize=999999`
                    + `&orderField=isQualified`
                    + `&orderDirection=desc`,
                method: "GET",
            }),
            providesTags: (result, error, favoriteId) => [{ type: "FavoriteFundersQueue", id: favoriteId }],
        }),
        moveFavoriteFunders: builder.mutation({
            query: ({destinationFavoriteId, favoriteFundersListId }) => ({
                url: `api/v1/foundation-service/favorite-funders/move${destinationFavoriteId === null ? '' : '/' + destinationFavoriteId}`,
                method: "POST",
                body: [...favoriteFundersListId]
            }),
        }),
        insertFavoriteFunders: builder.mutation({
            query: (model) => ({
                url: `api/v1/foundation-service/favorite-funders`,
                method: "POST",
                body: model
            }),
            invalidatesTags: ["FoundationTimeline"],
        }),
        deleteFavoriteFunders: builder.mutation({
            query: ({favoriteId, profileIdList}) => ({
                url: `api/v1/foundation-service/favorite-funders/${favoriteId}`,
                method: "DELETE",
                body: [...profileIdList]
            }),
            invalidatesTags: (result, error, { favoriteId }) => [{ type: "FavoriteFundersQueue", id: favoriteId }],
        }),
        updateQualifyFunder: builder.mutation({
            query: (model) => ({
                url: `api/v1/foundation-service/favorite-funders/qualify/${model.favoriteFunderId}/${model.isQualified === null ? '' : model.isQualified}`,
                method: "POST",
            }),
        }),
    }),
    overrideExisting: false,
});

export const {
    useGetFavoriteFundersPagedListMutation,
    useGetFavoriteFundersQueueQuery,
    useInsertFavoriteFundersMutation,
    useDeleteFavoriteFundersMutation,
    useMoveFavoriteFundersMutation,
    useUpdateQualifyFunderMutation
} = favoriteFundersApi;
